"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THEME_KEYS = exports.STANDARD_CHALK = void 0;
// chalk doesn't export a list of standard colors, so we have to supply our own
exports.STANDARD_CHALK = [
    'white',
    'black',
    'blue',
    'yellow',
    'green',
    'red',
    'magenta',
    'cyan',
    'gray',
    'blackBright',
    'redBright',
    'greenBright',
    'yellowBright',
    'blueBright',
    'magentaBright',
    'cyanBright',
    'whiteBright',
    'bgBlack',
    'bgRed',
    'bgGreen',
    'bgYellow',
    'bgBlue',
    'bgMagenta',
    'bgCyan',
    'bgWhite',
    'bgGray',
    'bgBlackBright',
    'bgRedBright',
    'bgGreenBright',
    'bgYellowBright',
    'bgBlueBright',
    'bgMagentaBright',
    'bgCyanBright',
    'bgWhiteBright',
    'bold',
    'underline',
    'dim',
    'italic',
    'strikethrough',
];
exports.THEME_KEYS = [
    'alias',
    'bin',
    'command',
    'commandSummary',
    'dollarSign',
    'flag',
    'flagDefaultValue',
    'flagOptions',
    'flagRequired',
    'flagSeparator',
    'sectionDescription',
    'sectionHeader',
    'topic',
    'version',
];
